import cogoToast from "cogo-toast";
import API from "../../utils/API";
import { ModalActionTypes } from '../Modal/modal.actionTypes';
import { userActionTypes } from "./user.action.types";

export const setCurrentUser = (user) => {
  return async (dispatch) => {
    try {
      if (user) {
        await dispatch({
          type: userActionTypes.SET_CURRENT_USER,
          payload: user,
        });
        console.log(user);
      }
    } catch (error) {
      if (error) {
        console.log(error);
        dispatch({ type: userActionTypes.AUTH_ERROR, payload: error.message });
      }
    }
  };
};

export const signupUser = (formData, history) => async (dispatch) => {
  try {
    const config = { headers: { "Content-Type": "application/json" } };
    const body = formData;
    const { data } = await API.post("/api/v1/users/register", body, config);
    await dispatch({ type: userActionTypes.SIGN_UP, payload: data.user });
    await localStorage.setItem('authToken', data.token);
    await dispatch(loadUser())
    await dispatch({ type: ModalActionTypes.HIDE_SIGNUP });
  } catch (error) {
    dispatch({
      type: userActionTypes.AUTH_ERROR,
      payload: error.response.data.error,
    });
    cogoToast.error(`${error.response.data.msg}`);
  }
};

export const loginUser = (email, password) => async (dispatch) => {
  try {
    const config = { headers: { "Content-Type": "application/json" } };
    const body = { email, password };
    const { data } = await API.post("/api/v1/users/login", body, config);
    await dispatch({ type: userActionTypes.LOG_IN, payload: data.user });
    await localStorage.setItem('authToken', data.token);
    await dispatch(loadUser())
    await dispatch({ type: ModalActionTypes.HIDE_LOGIN });

  } catch (error) {
    if (error.response) {
      dispatch({
        type: userActionTypes.AUTH_ERROR,
        payload: error.response.data.error,
      });
      cogoToast.error(`${error.response.data.msg}`);

    }
  }
};

export const loadUser = () => async (dispatch) => {
  try {
    const config = { headers: { "Content-Type": "application/json" } };
    const { data } = await API.get("/api/v1/users/loadUser", config);

    dispatch({ type: userActionTypes.SET_CURRENT_USER, payload: data.user });

  } catch (error) {
    if (error.response) {
      dispatch({
        type: userActionTypes.AUTH_ERROR,
        payload: error.message,
      });
    }
  }
};

export const loadGoogleUser = () => async (dispatch) => {
  const config = { headers: { "Content-Type": "application/json" } };
  try {
    const { data } = await API.get('/api/v1/auth/google', config);
    dispatch({ type: userActionTypes.SET_CURRENT_USER, payload: data.user });

  } catch (error) {
    if (error.response) {
      dispatch({
        type: userActionTypes.AUTH_ERROR,
        payload: error.message,
      });
      console.log(error.response);
      cogoToast.error(`${error.response.data.msg}`);

    }
  }
}
export const logOut = () => async dispatch => {

  try {
    await localStorage.removeItem('authToken');
    dispatch({ type: userActionTypes.LOG_OUT })

    // await API.get('/api/v1/log/logout')

  } catch (error) {
    console.log(error.message);
  }
}